import {defineMessages} from 'react-intl';

const messages = defineMessages({
  confirmDiscard: {
    id: 'communicator.confirmDiscard',
    defaultMessage: 'Discarding Message',
  },
  confirmDiscardContent: {
    id: 'communicator.confirmDiscardContent',
    defaultMessage: 'Are you sure you want to discard your message?',
  },
  recipients: {
    id: 'communicator.recipients',
    defaultMessage: 'Recipients',
  },
  person: {
    id: 'communicator.person',
    defaultMessage: 'Person',
  },
  people: {
    id: 'communicator.people',
    defaultMessage: 'People',
  },
  recipientsPanel: {
    id: 'communicator.recipientsPanel',
    defaultMessage: 'Recipients',
  },
  noRecipientsMessage: {
    id: 'communicator.noRecipientsMessage',
    defaultMessage: 'No recipients added',
  },
  noAdditionalRecipientsMessage: {
    id: 'communicator.noAdditionalRecipientsMessage',
    defaultMessage: 'No Additional recipients',
  },
  manageRecipients: {
    id: 'communicator.manageRecipients',
    defaultMessage: 'Manage Recipients',
  },
  messagePanel: {
    id: 'communicator.messagePanel',
    defaultMessage: 'Message',
  },
  surveyQuestionsTooltip: {
    id: 'communicator.surveyQuestionsTooltip',
    defaultMessage:
      'Up to five survey questions may be added to each message. Each question may have up to five optional (multiple choice, single select) responses. Questions and responses have a limit of 200 characters each. Regardless of optional responses, users will be allowed to submit an open-ended text response to each survey question. To compose a fully open-ended question, simply do not add any responses. Note that surveys sent via text-to-voice will not support open-ended responses. Survey questions will be available to recipients through an embedded link in the message and read aloud if sent via text-to-voice. Note that some countries do not allow links contained in SMS.',
  },
  surveyQuestionsLabel: {
    id: 'communicator.surveyQuestionsLabel',
    defaultMessage: 'Survey Questions',
  },
  attachment: {
    id: 'communicator.attachment',
    defaultMessage: 'Attachment',
  },
  senderRecipients: {
    id: 'communicator.senderRecipients',
    defaultMessage: 'Sender Recipients',
  },
  manageSenderRecipients: {
    id: 'communicator.manageSenderRecipients',
    defaultMessage: 'Manage Sender Recipients',
  },
  group: {
    id: 'communicator.group',
    defaultMessage: 'Group',
  },
  groups: {
    id: 'communicator.groups',
    defaultMessage: 'Groups',
  },
  site: {
    id: 'communicator.site',
    defaultMessage: 'Site',
  },
  sites: {
    id: 'communicator.sites',
    defaultMessage: 'Sites',
  },
  savedSearch: {
    id: 'communicator.savedSearch',
    defaultMessage: 'Saved Search',
  },
  savedSearches: {
    id: 'communicator.savedSearches',
    defaultMessage: 'Saved Searches',
  },
  autoTranslateLabel: {
    id: 'communicator.autoTranslateLabel',
    defaultMessage: 'Do Not Auto-Translate Message',
  },
  autoTranslateTooltip: {
    id: 'communicator.autoTranslateTooltip',
    defaultMessage:
      'Messages are automatically translated and delivered to recipients in their preferred language. If you wish to send this message in the language it is written and not allow translation, check this box. Recipients that do not have a preferred language specified will receive the message as-is.',
  },
  desktopAlertPropertiesLabel: {
    id: 'communicator.desktopAlertPropertiesLabel',
    defaultMessage: 'Desktop Alert Properties',
  },
  desktopAlertSubjectLabel: {
    id: 'communicator.desktopAlertSubjectLabel',
    defaultMessage: 'Desktop Alert Subject',
  },
  desktopAlertSizeLabel: {
    id: 'communicator.desktopAlertSizeLabel',
    defaultMessage: 'Size',
  },
  desktopAlertColorLabel: {
    id: 'communicator.desktopAlertColorLabel',
    defaultMessage: 'Color',
  },
  desktopAlertSoundLabel: {
    id: 'communicator.desktopAlertSoundLabel',
    defaultMessage: 'Alert Sound',
  },
  // Desktop Alert Size Options
  desktopAlertSizeCompact: {
    id: 'communicator.desktopAlertSizeCompact',
    defaultMessage: 'Compact',
  },
  desktopAlertSizeExpanded: {
    id: 'communicator.desktopAlertSizeExpanded',
    defaultMessage: 'Expanded',
  },
  desktopAlertSizeFullScreen: {
    id: 'communicator.desktopAlertSizeFullScreen',
    defaultMessage: 'Full-screen',
  },
  // Desktop Alert Color Options
  desktopAlertColorGreen: {
    id: 'communicator.desktopAlertColorGreen',
    defaultMessage: 'Green',
  },
  desktopAlertColorYellow: {
    id: 'communicator.desktopAlertColorYellow',
    defaultMessage: 'Yellow',
  },
  desktopAlertColorRed: {
    id: 'communicator.desktopAlertColorRed',
    defaultMessage: 'Red',
  },
  // Desktop Alert Sound Options
  desktopAlertSoundRing: {
    id: 'communicator.desktopAlertSoundRing',
    defaultMessage: 'Ring',
  },
  desktopAlertSoundBeep: {
    id: 'communicator.desktopAlertSoundBeep',
    defaultMessage: 'Beep',
  },
  desktopAlertSoundAlarm: {
    id: 'communicator.desktopAlertSoundAlarm',
    defaultMessage: 'Alarm',
  },
  desktopAlertSoundNoSound: {
    id: 'communicator.desktopAlertSoundNoSound',
    defaultMessage: 'No Sound',
  },
});

export default messages;
